import { DashCard } from "../../../../script/components/dash-board/dash-card/dash-card";
import { ScrollGrid } from "../../../../script/components/data-grid/data-grid-body/grid-bodys";
import { CommCol, DeciCol } from "../../../../script/components/data-grid/data-grid-column/grid-column";
import { Summary } from "devextreme-react/cjs/data-grid";
import { GroupSumItem } from "../../../../script/components/data-grid/data-grid-body/grid-body-item";
import { fwUtil } from "../../../../script/util";

const itemGroupRender = (data) => {

    if (!data && (data && data.length < 1)) {
        return;
    }

    if (!data.summaryItems) {
        return;
    }
    const ordeColumn = data.summaryItems[0];
    const kwonColumn = data.summaryItems[1];

    if (!ordeColumn || !kwonColumn) {
        return;
    }

    return (
        <div className='fw-summary-group'>
            <div className='fw-group-title'>
                {data.displayValue}
            </div>
            <div className='fw-group-detail'>
                총 {ordeColumn.columnCaption} : <b>{ordeColumn.value}</b> 건
            </div>
            <div className='fw-group-detail'>
                총 {kwonColumn.columnCaption} : <b>{fwUtil.conv.to.krLocales(kwonColumn.value)}</b> 건
            </div>
        </div>
    )
}

export function DashItemGridCard(props) {
    const { loading, data } = props;
    return (
        <DashCard
            title={"제품별 현황"}
            addClass={'item'}
            loading={loading}
        >
            <ScrollGrid
                gridDataSource={data}
                height={250}
                mainKey={["item_code", "insp_gubu"]}
                selection={'single'}
                direction={'vertical'}
            >
                {CommCol({ dataField: "item_name", caption: "제품명", groupIndex: 0, groupRender: itemGroupRender })}
                {CommCol({ dataField: "insp_gubu", caption: "검사구분" })}
                {DeciCol({ dataField: "insp_qtys", caption: "검사수량" })}
                {DeciCol({ dataField: "judg_qtys", caption: "판정수량" })}
                <Summary>
                    {GroupSumItem({ dataField: "insp_qtys", suffix: "건" })}
                    {GroupSumItem({ dataField: "judg_qtys", suffix: "건" })}
                </Summary>
            </ScrollGrid>
        </DashCard>
    )
}